<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <table class="table table-sm" style="width: 100%; table-layout: fixed" v-if="bridge">
            <tbody>
            <tr>
                <td class="item-detail-title">
                    {{ $t('common.id') }}
                </td>
                <td class="item-detail-text">
                    <span v-if="bridge.id">{{ bridge.id }}</span>
                    <span v-else>-</span>
                </td>
            </tr>
            <tr>
                <td class="item-detail-title">
                    {{ $t('bridge.name') }}
                </td>
                <td class="item-detail-text">
                    <span v-if="bridge.name">{{ bridge.name }}</span>
                    <span v-else>-</span>
                </td>
            </tr>
            <tr>
                <td class="item-detail-title">
                    {{ $t('bridge.code') }}
                </td>
                <td class="item-detail-text">
                    <span v-if="bridge.code">{{ bridge.code }}</span>
                    <span v-else>-</span>
                </td>
            </tr>
            <tr>
                <td class="item-detail-title">
                    {{ $t('bridge.owner') }}
                </td>
                <td class="item-detail-text">
                    <span v-if="bridge.owner">{{ bridge.owner }}</span>
                    <span v-else>-</span>
                </td>
            </tr>
            <tr>
                <td class="item-detail-title">
                    {{ $t('bridge.maintainer') }}
                </td>
                <td class="item-detail-text">
                    <span v-if="bridge.maintainer">{{ bridge.maintainer }}</span>
                    <span v-else>-</span>
                </td>
            </tr>
            </tbody>
        </table>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>

</template>

<script>
import {restApi} from "@/components/mixins/RestApiMixin";

export default {
    name: 'TargetInfoBridge',
    mixins: [restApi],
    props: {
        bridgeId: {
            type: Number,
            default: null
        }
    },
    data: function () {
        return {
            bridge: null,
            loading: false
        }
    },
    created() {
        this.fetchBridgeInfo()
    },
    methods: {
        fetchBridgeInfo: function () {
            this.loading = true
            this.restFetchParams(this.bridgeUrl + "/" + this.bridgeId, this.params, this.handleResponse)
        },
        handleResponse: function (response) {
            this.loading = false
            if (response) {
                this.bridge = response.data
            }
        }
    }
}
</script>
